var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 48V45.48L21 41.88V26.82L0 33V29.52L21 17.16V3C21 2.16 21.29 1.45 21.87 0.87C22.45 0.29 23.16 0 24 0C24.84 0 25.55 0.29 26.13 0.87C26.71 1.45 27 2.16 27 3V17.16L48 29.52V33L27 26.82V41.88L31.8 45.48V48L24 45.78L16.2 48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVTravel);
export default __webpack_public_path__ + "static/media/whiteVTravel.7d134b03613d42ba61cc25db215155c8.svg";
export { ForwardRef as ReactComponent };